import en from './en-GB.json';
import sl from './sl-SI.json';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    resources: {
        'sl-SI': {
            translation: sl,
        },
        'en-GB': {
            translation: en,
        },
    },
    lng: 'sl-SI',
    supportedLngs: ['sl-SI', 'en-GB'],
    fallbackLng: 'sl-SI',
});

export default i18n;
